"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = _interopRequireDefault(require("./constant"));
var _default = exports.default = {
  PropTypes: {
    title: _propTypes.string.isRequired,
    value: _propTypes.any,
    titleColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    subtitle: _propTypes.string,
    subtitleColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    subtitleTextAlign: _propTypes.string,
    subtitleType: _propTypes.string,
    backgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
    hoverBackgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
    active: _propTypes.bool,
    activeTitleColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    activeSubtitleColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    activeBorderColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    onClick: _propTypes.func,
    width: _propTypes.string,
    height: _propTypes.string,
    borderColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    center: _propTypes.bool,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    index: _propTypes.number,
    alignCenter: _propTypes.bool,
    unsetTextAlignLast: _propTypes.bool,
    minHeight: _propTypes.string,
    defaultBorderColor: _propTypes.string,
    enableHover: _propTypes.bool,
    titleType: _propTypes.string,
    activeBackGroundColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    toggleOnClick: _propTypes.bool,
    bold: _propTypes.bool,
    unsetPaddingLeft: _propTypes.bool,
    setActionName: _propTypes.func
  },
  DefaultProps: {
    titleColor: _constant2.default.TITLE_COLOR,
    subtitleColor: _constant2.default.SUBTITLE_COLOR,
    backgroundColor: _constant2.default.BACKGROUND_COLOR,
    hoverBackgroundColor: _constant2.default.HOVER_BACKGROUND_COLOR,
    active: false,
    activeBorderColor: _constant2.default.ACTIVE_BORDER_COLOR,
    center: false,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    alignCenter: false,
    unsetTextAlignLast: false,
    enableHover: true,
    toggleOnClick: true,
    bold: false,
    unsetPaddingLeft: false,
    onClick: () => {}
  }
};